window.addEventListener("DOMContentLoaded", (event) => {

    // 1. Gestion des éléments parents (avec enfants)
    document.querySelectorAll('ul.mobile-drilldown-menu li.menu-item-has-children > a').forEach(element => {

        // --- Bouton RETOUR (Précédent) ---
        let previous = document.createElement('span');
        element.nextElementSibling.prepend(previous);
        previous.classList.add("pdw-submenu-close");
        previous.innerHTML = element.innerHTML;
        previous.addEventListener("click", (event) => {
            event.preventDefault();
            event.target.parentElement.parentElement.classList.remove("open");
        });

        // --- Bouton OUVRIR (la flèche) ---
        let span = document.createElement('span');
        element.appendChild(span);
        span.classList.add("pdw-submenu-open");

        span.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation(); // Empêche le clic de remonter vers le lien <a>
            element.parentElement.classList.add("open");
            document.getElementById('pdw-mobile-menu').scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
        });

        // --- Clic sur le LIEN PARENT lui-même ---
        element.addEventListener("click", (event) => {
            // Si on clique sur le texte du lien et non sur la flèche
            if (event.target !== span) {
                const closeButton = document.querySelector('.pdw-mobile-menu-close');
                if (closeButton) closeButton.click();
            }
        });
    });

    // 2. Gestion des liens sans enfants (News, etc.)
    document.querySelectorAll('ul.mobile-drilldown-menu li:not(.menu-item-has-children) > a').forEach(link => {
        link.addEventListener("click", () => {
            const closeButton = document.querySelector('.pdw-mobile-menu-close');
            if (closeButton) closeButton.click();
        });
    });
});